
import { Component, Vue } from "vue-property-decorator";
import { inputData } from "./input.data";
import { ProjectView } from "@/views/project-view";

@Component
export default class Input extends ProjectView {
    get inputComponents() {
        return inputData;
    }

    get input_inf() {
        return require("raw-loader!./input.interface").default;
    }

    numberValue = null;
    stringValue = null;
}
